import ServiceTwoIcon from "./ServiceTwoIcon";

export default function ServiceCatalogCard({ service, selected, onClick }) {
  return (
    <button
      type="button"
      className={`service-catalog-card${selected ? " is-selected" : ""}`}
      onClick={onClick}
      aria-pressed={selected}
      aria-label={`${service.title}${selected ? "، انتخاب شده" : ""}`}
    >
      <span className="service-catalog-card__icon">
        <ServiceTwoIcon name={service.icon} />
      </span>
      <span className="service-catalog-card__copy">
        <b>{service.title}</b>
        <small>{service.description}</small>
      </span>
      {selected ? (
        <span className="service-catalog-card__count">
          <ServiceTwoIcon name="check" />
          انتخاب شد
        </span>
      ) : (
        <span className="service-catalog-card__add">انتخاب</span>
      )}
    </button>
  );
}
